export default "__VITE_ASSET__BevD2KP4__"